module.exports = "/images/equal-housing.png?35d356e29fca1675886fb0162ea9414e";